import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./ClassPerformance.module.css";
import { Link } from "react-router-dom";
import { Chip, Paper, styled } from "@mui/material";
import DatePickerSample from "../../DatePicker";
import Pagination from "../../../ReusuableComponent/Pagination/Pagination";
import { R_PER_PAGE } from "../../../../labels";
import CustomDownloadButton from "../../../ReusuableComponent/CustomDownloadButton/CustomDownloadButton";
function ClassPerformance({
  isLoading,
  setIsLoading,
  onSort,
  initialfields,
  handleChange,
  reportData,
  reportData1,
  handleFilterSearch,
  handleFilterSubjectSearch,
  handleFilterTestTopicSearch,
  eventName,
  setSelectedEvent,
  selectedEvent,
  handleCheckboxChange,
  updateChipData,
  handleApplyFilter,
  selectedSubject,
  selectedTestTopics,
  setselectedStatus,
  selectedStatus,
  subject,
  setSelectedSubject,
  setSelectedTestTopics,
  selectedToppics,
  testTopics,
  settestTopics,
  dateFilter,
  handleDateFilterChange,
  setIsopen,
  isOpen,
  setAppData,
  appData,
  handleDelete,
  handleAllClear,
  handleClear,
  handleAppliedOn,
  handleChangeDate,
  setAppOn, // Keep only one instance of setAppOn
  appOn,
  batchId,
  batchType,
  activeTab,
  handleView,
  searchTerm,
  setSearchTerm,
  handleSearch,
  handleSearchFocus,
  txtBSearch,
}) {
  const ListItem = styled("li")(({ theme }) => ({
    margin: theme.spacing(0.5),
  }));
  const fDatePickerRef = useRef(null);
  const tDatePickerRef = useRef(null);
  const filterTestTopicRef = useRef(null);
  const [expandedId, setExpandedId] = useState(null);
  const [test_topics, setTest_topics] = useState([]);
  const [mediums, setMedium] = useState([]);
  const [ssubject, setSsubject] = useState([]);
  const [ssubjects, setSsubjects] = useState(ssubject);
  const [ssubjectsFiltered, setSsubjectsFiltered] = useState(ssubjects);
  const [testTopicsFiltered, setTestTopicsFiltered] = useState(testTopics);
  const toggleExpand = (id) => {
    setExpandedId(expandedId === id ? null : id);
  };
  let page = R_PER_PAGE;
  const [ranges, setRanges] = useState([30, 60]);
  const [rowsPerPage, setRowsPerPage] = useState(page);
  const [currentPage, setCurrentPage] = useState(1);
  const navigate = useNavigate();
  const handleFilter = (e, filterKey) => {
    setIsopen((prev) => ({
      ...prev,
      [filterKey]: !prev[filterKey],
    }));
  };
  const generateCSVData = () => {
    const headers = [
      "S.No",
      "Class Name",
      "Date",
      "Subject",
      "Test Topic",
      "Status",
    ];
    const rows = [];
    let serialNumber = 1;

    currentData.forEach((item) => {
      if (item.type === "single_exam") {
        rows.push([
          serialNumber++,
          item.event_name || "",
          item.start_date
            ? new Date(item.start_date).toLocaleDateString("en-GB")
            : "",
          item.subject?.map((subj) => subj.subject).join(", ") || "",
          item.test_topic?.map((topic) => topic.test_topic).join(", ") || "",
          item.status === 1 ? "Completed" : "Absent",
        ]);
      } else if (item.type === "combined_exam") {
        // Add parent row for combined exam
        rows.push([
          serialNumber++,
          item.exam_name || "",
          "", // No date for parent
          "", // No subject for parent
          "", // No test topic for parent
          "", // No status for parent
        ]);

        // Add child rows for each exam in the combined exam
        item.exam_data?.forEach((child) => {
          rows.push([
            "", // Empty serial number for child rows
            child.event_name || "",
            child.start_date
              ? new Date(child.start_date).toLocaleDateString("en-GB")
              : "",
            child.subject?.map((subj) => subj.subject).join(", ") || "",
            child.test_topic?.map((topic) => topic.test_topic).join(", ") || "",
            child.status === 1 ? "Completed" : "Absent",
          ]);
        });
      }
    });

    return [headers, ...rows];
  };
  const generatePDF = () => {
    const headers = [
      "S.No",
      "Class Name",
      "Date",
      "Subject",
      "Test Topic",
      "Status",
    ];

    let serialNumber = 1;
    const rows = [];

    mergedData.forEach((item) => {
      if (item.type === "single_exam") {
        rows.push([
          serialNumber++,
          item.event_name ?? "-",
          item.start_date
            ? new Date(item.start_date).toLocaleDateString("en-GB")
            : "-",
          Array.isArray(item.subject)
            ? item.subject.map((s) => s.subject).join(", ")
            : "-",
          Array.isArray(item.test_topic)
            ? item.test_topic.map((t) => t.test_topic).join(", ")
            : "-",
          item.status === 1 ? "Completed" : "Absent",
        ]);
      } else if (item.type === "combined_exam") {
        // Add parent combined exam row
        rows.push([
          serialNumber++,
          item.exam_name ?? "-",
          "-",
          "-",
          "-",
          "-", // skip ranks and status
        ]);

        // Add child exams
        item.exam_data?.forEach((child) => {
          rows.push([
            "", // no serial for child
            child.event_name ?? "-",
            child.start_date
              ? new Date(child.start_date).toLocaleDateString("en-GB")
              : "-",
            Array.isArray(child.subject)
              ? child.subject.map((s) => s.subject).join(", ")
              : "-",
            Array.isArray(child.test_topic)
              ? child.test_topic.map((t) => t.test_topic).join(", ")
              : "-",
            child.status === 1 ? "Completed" : "Absent",
          ]);
        });
      }
    });

    // Navigate to preview page with table structure
    navigate("/preview", {
      state: {
        title: "Class Performance Data",
        headers,
        rows,
        filename: "ClassPerformance.pdf",
        autoPrint: true,
      },
    });
  };
  const filterEventNameRef = useRef(null);
  const filterDateRef = useRef(null);
  const filterSubjectRef = useRef(null);
  const filterStatusRef = useRef(null);
  const filterTotalMarksRef = useRef(null);
  // Combine both arrays safely
  const combinedData = [
    ...(Array.isArray(reportData) ? reportData : []),
    ...(Array.isArray(reportData1) ? reportData1 : []),
  ];
  const mergedData = [...reportData, ...reportData1];
  const totalRecords = mergedData.length;
  const totalPages = Math.ceil(totalRecords / rowsPerPage);
  const start = (currentPage - 1) * rowsPerPage;
  const end = start + rowsPerPage;
  const currentData = mergedData.slice(start, end);
  // prev button pagination
  const handlePrev = (val) => {
    setCurrentPage(val);
  };
  // next button pagination
  const handleNext = (val) => {
    setCurrentPage(val);
  };
  const handlePageCount = (e) => {
    setRowsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      // ✅ Event Name
      if (
        filterEventNameRef.current &&
        !filterEventNameRef.current.contains(event.target) &&
        !event.target.closest(".react-datepicker")
      ) {
        const hasEventName = updateChipData.some(
          (chipItem) => chipItem.type === "eventName"
        );

        if (hasEventName) {
          const updatedEventName = updateChipData.filter(
            (chipItem) => chipItem.type === "eventName"
          );
          setSelectedEvent(updatedEventName);
        } else {
          setSelectedEvent([]);
        }

        setIsopen((prev) => ({ ...prev, eventName: false }));
      }

      // ✅ Date
      if (
        filterDateRef.current &&
        !filterDateRef.current.contains(event.target) &&
        !event.target.closest(".react-datepicker") &&
        !event.target.closest(".filterBoxOne_Con")
      ) {
        const dateChip = updateChipData.find(
          (chipItem) =>
            chipItem.type === "dayRange" || chipItem.type === "dateRange"
        );

        if (dateChip) {
          if (dateChip.type === "dayRange") {
            setAppData({
              FDate: "",
              TDate: "",
              Days: dateChip.Days,
              name: "",
            });
          } else {
            setAppData({
              FDate: dateChip.fdate,
              TDate: dateChip.edate,
              Days: "",
              name: "",
            });
          }
          setAppOn([dateChip]);
        } else {
          setAppData({
            FDate: "",
            TDate: "",
            Days: "",
            name: "",
          });
          setAppOn([]);
        }

        setIsopen((prev) => ({ ...prev, appliedOn: false }));
      }

      // ✅ Subject
      if (
        filterSubjectRef.current &&
        !filterSubjectRef.current.contains(event.target) &&
        !event.target.closest(".react-datepicker")
      ) {
        const hasSubject = updateChipData.some(
          (chipItem) => chipItem.type === "subject"
        );

        if (hasSubject) {
          const updatedSubject = updateChipData.filter(
            (chipItem) => chipItem.type === "subject"
          );
          setSelectedSubject(updatedSubject);
        } else {
          setSelectedSubject([]);
        }

        setIsopen((prev) => ({ ...prev, subject: false }));
      }

      // ✅ Test Topic
      if (
        filterTestTopicRef.current &&
        !filterTestTopicRef.current.contains(event.target) &&
        !event.target.closest(".react-datepicker")
      ) {
        const hasTestTopic = updateChipData.some(
          (chipItem) => chipItem.type === "testTopic"
        );

        if (hasTestTopic) {
          const updatedTestTopic = updateChipData.filter(
            (chipItem) => chipItem.type === "testTopic"
          );
          setSelectedTestTopics(updatedTestTopic);
        } else {
          setSelectedTestTopics([]);
        }

        setIsopen((prev) => ({ ...prev, testTopic: false })); // 👈 close popup
      }

      //  Status
      if (
        filterStatusRef.current &&
        !filterStatusRef.current.contains(event.target) &&
        !event.target.closest(".react-datepicker")
      ) {
        const hasStatus = updateChipData.some(
          (chipItem) => chipItem.type === "status"
        );

        if (hasStatus) {
          const updatedStatus = updateChipData.filter(
            (chipItem) => chipItem.type === "status"
          );
          setselectedStatus(updatedStatus);
        } else {
          setselectedStatus([]);
        }

        setIsopen((prev) => ({ ...prev, status: false }));
      }

      //  Total Marks
      if (
        filterTotalMarksRef.current &&
        !filterTotalMarksRef.current.contains(event.target) &&
        !event.target.closest(".react-datepicker")
      ) {
        setIsopen((prev) => ({ ...prev, tot_marks: false }));
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [updateChipData]);

  return (
    <div className={`container-fluid  global_container BathDet p-0`}>
      <div className="row ">
        <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-2">
          <div class="input-group">
            <input
              ref={txtBSearch}
              type="text"
              class={styles.Inputs}
              id="SearchInput"
              name="SearchInput"
              placeholder="Search by Class Names, Subject, Class Topics"
              onChange={(e) => {
                setSearchTerm(e.target.value);
              }}
              onKeyDown={handleSearch}
            />
            <span
              class={styles.input_group_text}
              id="SearchInput"
              onClick={handleSearchFocus}
            >
              <span className="material-icons" onClick={handleSearchFocus}>
                search
              </span>
            </span>
          </div>
        </div>

        {/* <div className="col-md-8 col-12 ListBtn">
          <ul className="List-Button">
            <li class="ListBtnItems">
              <CustomDownloadButton
                csvListData={generateCSVData()}
                iconName=" file_download "
                filename={"TestPerfomance.csv"}
                csvName="  Download as CSV"
              />
            </li>
            <li class="ListBtnItems primaryButton" onClick={generatePDF}>
              <span className="material-icons me-1 align-middle text-white">
                file_download
              </span>
              Download as PDF
            </li>
          </ul>
        </div> */}
      </div>
      {updateChipData?.length > 0 ? (
        <div className="row mt-3">
          <div className="col-md-12 col-sm-12 col-xs-12 paperil_global">
            <Paper
              sx={{
                display: "flex",
                justifyContent: "center",
                flexWrap: "wrap",
                listStyle: "none",
                p: 0.5,
                m: 0,
              }}
              component="ul"
            >
              {updateChipData.map((data, index) => {
                let icon;
                return (
                  <ListItem key={index}>
                    <Chip
                      icon={icon}
                      label={
                        <>
                          <span className={"BoldTyText"}>
                            {data.type === "price"
                              ? `Price: ${data.name}`
                              : data.name}
                          </span>
                        </>
                      }
                      onDelete={handleDelete(data, index)}
                    />
                  </ListItem>
                );
              })}
              <ListItem className="clearAll_list">
                <a
                  className="clearAll_listItem"
                  href="javascript:void(0)"
                  onClick={handleAllClear}
                >
                  Clear All Filters
                </a>
              </ListItem>
            </Paper>
          </div>
        </div>
      ) : (
        // No chips to show
        <div></div>
      )}
      <div className="row mt-2 mx-0">
        <div className="col-md-12 table-responsive tableMinHeight px-0">
          <table className="table" id="tableListHeader">
            <thead>
              <tr>
                {/* Class Name */}
                <th id="th">
                  <span className="text_th"> Class Name</span>{" "}
                  <span
                    className={`align-middle material-icons ${
                      selectedEvent.length > 0 || isOpen.eventName
                        ? styles.active_icons_book
                        : ""
                    }`}
                    onClick={(e) => handleFilter(e, "eventName")}
                   
                    style={{ cursor: "pointer" }}
                  >
                    filter_list
                  </span>
                  {isOpen.eventName === true && (
                    <div
                      className="filterBoxs_testlist p-1"
                      ref={filterEventNameRef}
                      style={{ left: "5px" }}
                    >
                      <div className="filterBoxText ">
                        <div className="row ms-1">
                          <div className="col-lg-12 col-md-12">
                            <div className="input-group searchInputsss">
                              <input
                                type="text"
                                className="Inputs"
                                id="SearchFilterInputs"
                                placeholder="Search Here"
                                onChange={(e) =>
                                  handleFilterSearch(e, "eventName")
                                }
                              />
                              <span
                                className="input-group-text"
                                id="SearchInput"
                              >
                                <span className="material-icons">search</span>
                              </span>
                            </div>
                          </div>
                        </div>
                        <hr />
                        {eventName.map((el) => (
                          <div className="row mt-2" key={el.event_pk}>
                            <div className="col-md-12">
                              <div className="form-check">
                                <input
                                  className="ListCheckbox"
                                  type="checkbox"
                                  name={el.event_name}
                                  value={el.event_pk}
                                  id={`event-${el.event_pk}`}
                                  checked={selectedEvent.some(
                                    (element) =>
                                      element.id === String(el.event_pk)
                                  )}
                                  onChange={(e) =>
                                    handleCheckboxChange(e, "eventName")
                                  }
                                />
                                <label
                                  className="form-check-label PinkText"
                                  htmlFor={`event-${el.event_pk}`}
                                >
                                  {el.event_name}
                                </label>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                      <div className="borderWidth row">
                        <ul className="List-Button">
                          <li className="ListBtnItems">
                            <Link
                              to={"javascript:void(0)"}
                              onClick={() => handleClear("eventName")}
                              className="secondaryButton ms-2"
                            >
                              Clear
                            </Link>
                          </li>
                          <li className="ListBtnItems">
                            <Link
                              to={"javascript:void(0)"}
                              onClick={() => handleApplyFilter("eventName")}
                              className="primaryButton"
                            >
                              Apply Filter
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  )}
                </th>
                {/* Date */}
                <th id="th">
                  <span
                    onClick={() => onSort("start_date")}
                    className="textHead_th px-1"
                  >
                    Date
                  </span>
                  <span
                    onClick={() => onSort("start_date")}
                    className={`material-icons textHead_th align-middle`}
                  >
                    import_export
                  </span>
                  <span
                    onClick={(e) => {
                      e.stopPropagation();
                      handleFilter(e, "appliedOn");
                    }}
                    className={` textHead_th align-middle material-icons ${
                      (appData &&
                        Object.entries(appData).some(
                          ([key, val]) =>
                            key !== "name" &&
                            val !== null &&
                            val !== undefined &&
                            val.toString().trim() !== ""
                        )) ||
                      isOpen.appliedOn
                        ? styles.active_icons_book
                        : ""
                    }`}
                  >
                    filter_list
                  </span>

                  {isOpen.appliedOn === true && (
                    <div
                      className="filterBoxs_testlist mt-2 p-2"
                      ref={filterDateRef}
                      onClick={(e) => e.stopPropagation()}
                      style={{
                        left: "10px",
                      }}
                    >
                      <div className="form-check p-1">
                        <label
                          htmlFor="startDate"
                          className="form-label confirm_value me-1"
                        >
                          From Date
                        </label>
                        <DatePickerSample
                          IconInput="LI_filterIocnBoxInputTest"
                          className="LI_FilterInputs"
                          name="FDate"
                          handleChange={handleChangeDate}
                          fieldInput={appData.FDate}
                          txtAdMDob={fDatePickerRef}
                        />
                      </div>

                      <div className="form-check p-1 mt-2">
                        <label
                          htmlFor="endDate"
                          className="form-label confirm_value me-1"
                        >
                          To Date{" "}
                          <span data-required="true" aria-hidden="true"></span>
                        </label>
                        <DatePickerSample
                          IconInput="LI_filterIocnBoxInputTest"
                          className="LI_FilterInputs"
                          name="TDate"
                          handleChange={handleChangeDate}
                          fieldInput={appData.TDate}
                          txtAdMDob={tDatePickerRef}
                          minDate={appData.FDate}
                        />
                      </div>

                      <div className="row mt-3">
                        {[
                          { id: "Today", label: "Today" },
                          { id: "Yesterday", label: "Yesterday" },
                          { id: "Tweek", label: "This Week" },
                          { id: "Lweek", label: "Last Week" },
                          { id: "Tmonth", label: "This Month" },
                          { id: "Lmonth", label: "Last Month" },
                        ].map(({ id, label }) => (
                          <div key={id} className="col-md-6 col-6">
                            <div className="form-check">
                              <input
                                type="radio"
                                className="form-check-input"
                                id={id}
                                name="Days"
                                value={id}
                                checked={appData.Days === id}
                                onChange={handleAppliedOn}
                              />
                              <label
                                className="form-check-label d-flex"
                                htmlFor={id}
                                style={{ fontWeight: "bold" }}
                              >
                                {label}
                              </label>
                            </div>
                          </div>
                        ))}
                      </div>
                      <div className="borderWidth row">
                        <ul className="List-Button">
                          <li className="ListBtnItems">
                            <Link
                              to={"javascript:void(0)"}
                              onClick={() => handleClear("startDate")}
                              className="secondaryButton"
                            >
                              Clear
                            </Link>
                          </li>
                          <li className="ListBtnItems">
                            <Link
                              onClick={() => handleApplyFilter("startDate")}
                              className="primaryButton"
                            >
                              Apply Filter
                            </Link>
                          </li>
                        </ul>
                      </div>
                      {/* <div className="borderWidth row row mt-2">
                          <div className="col-md-4 col-4">
                            <span
                              className="clearFilter ms-2"
                              onClick={() => handleClear("startDate")}
                            >
                              Clear
                            </span>
                          </div>
                          <div className="col-md-8 col-8 text-end">
                            <button
                              className="primaryButton"
                              onClick={handleApplyFilter}
                            >
                              Apply Filter2
                            </button>
                          </div>
                        </div> */}
                    </div>
                  )}
                </th>
                {/* Subject */}
                <th id="th">
                  <span className="text_th"> Subject </span>{" "}
                  {/* <span
                    class="material-icons align-middle"
                    onClick={(e) => handleSort(e, "subject")}
                  >
                    import_export
                  </span> */}
                  <span
                    class={` align-middle material-icons  ${
                      selectedSubject.length > 0 || isOpen.subject
                        ? styles.active_icons_book
                        : ""
                    }`}
                    onClick={(e) => handleFilter(e, "subject")}
                  >
                    filter_list
                  </span>
                  {isOpen.subject === true && (
                    <div className="filterBoxs p-1" ref={filterSubjectRef}>
                      <div className="filterBoxText ">
                        <div className="row ms-1">
                          <div className="col-lg-12 col-md-12">
                            <div class="input-group searchInputsss">
                              <input
                                type="text"
                                class="Inputs width_75"
                                id="SearchFilterInput"
                                name="SearchFilterInput"
                                placeholder="Search Here"
                                // onChange={handleSearch}
                                onKeyDown={(e) =>
                                  handleFilterSearch(e, "subject")
                                }
                              />
                              <span class="input-group-text" id="SearchInput">
                                <span className="material-icons">search</span>
                              </span>
                            </div>
                          </div>
                        </div>
                        <hr />
                        {subject.map((el) => (
                          <div className="row mt-2 ">
                            <div className="col-md-12">
                              <div class="form-check ms-3">
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  name={el.subject}
                                  value={el.subject_pk}
                                  id={el.subject}
                                  checked={selectedSubject.some((element) => {
                                    if (element.id == el.subject_pk) {
                                      return true;
                                    }
                                    return false;
                                  })}
                                  onChange={(e) =>
                                    handleCheckboxChange(e, "subject")
                                  }
                                />
                                <label
                                  class="form-check-label PinkText"
                                  for="defaultCheck1"
                                  htmlFor={el.subject}
                                >
                                  {el.subject}
                                </label>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                      <hr />
                      <div className="row mt-3">
                        <div className="col-md-4  col-4 col-sm-4">
                          <span
                            className="clearFilter ms-2 "
                            style={{ cursor: "pointer" }}
                            onClick={() => handleClear("subject")}
                          >
                            Clear
                          </span>
                        </div>
                        <div className="col-md-8  col-8 col-sm-8">
                          <button
                            className="FilterButton"
                            onClick={() => handleApplyFilter("subject")}
                          >
                            Apply Filter
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </th>
                {/* Test Topic */}
                <th id="th">
                  <span className="text_th"> Class Topic </span>
                  <span
                    className={`align-middle material-icons ${
                      test_topics.length > 0 || isOpen.testTopic
                        ? styles.active_icons_book
                        : ""
                    }`}
                    onClick={(e) => handleFilter(e, "testTopic")}
                  >
                    filter_list
                  </span>
                  {isOpen.testTopic === true && (
                    <div className="filterBoxs p-1" ref={filterTestTopicRef}>
                      <div className="filterBoxText">
                        <div className="row ms-1">
                          <div className="col-lg-12 col-md-12">
                            <div className="input-group searchInputsss">
                              <input
                                type="text"
                                className="Inputs"
                                id="SearchFilterInputs"
                                placeholder="Search Here"
                                onChange={(e) =>
                                  handleFilterSearch(e, "subjects")
                                }
                              />
                              <span
                                className="input-group-text"
                                id="SearchInput"
                              >
                                <span className="material-icons">search</span>
                              </span>
                            </div>
                          </div>
                        </div>
                        <hr />
                        {subject.map(
                          (
                            el //  use subjects (filtered list), not subject
                          ) => (
                            <div className="row mt-2" key={el.subject_pk}>
                              <div className="col-md-12">
                                <div className="form-check">
                                  <input
                                    className="ListCheckbox"
                                    type="checkbox"
                                    name={el.subject}
                                    value={el.subject_pk}
                                    id={`subject-${el.subject_pk}`}
                                    checked={subject.some(
                                      (element) =>
                                        element.id === String(el.subject_pk)
                                    )}
                                    onChange={(e) =>
                                      handleCheckboxChange(e, "subject")
                                    }
                                  />
                                  <label
                                    className="form-check-label PinkText"
                                    htmlFor={`subject-${el.subject_pk}`}
                                  >
                                    {el.subject}
                                  </label>
                                </div>
                              </div>
                            </div>
                          )
                        )}
                      </div>
                      <div className="borderWidth row">
                        <ul className="List-Button">
                          <li className="ListBtnItems">
                            <Link
                              to={"javascript:void(0)"}
                              onClick={() => handleClear("subject")}
                              className="secondaryButton ms-2"
                            >
                              Clear
                            </Link>
                          </li>
                          <li className="ListBtnItems">
                            <Link
                              to={"javascript:void(0)"}
                              onClick={() => handleApplyFilter("subject")}
                              className="primaryButton"
                            >
                              Apply Filter
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  )}
                </th>

              

                {/* Status */}
                <th id="th">
                  <span
                    onClick={() => onSort("status")}
                    className="textHead_th"
                  >
                    Status
                  </span>
                  <span
                    onClick={() => onSort("status")}
                    className="textHead_th material-icons align-middle"
                  >
                    import_export
                  </span>
                  <span
                    className={`align-middle material-icons color-table ${
                      selectedStatus.length > 0 || isOpen.status
                        ? styles.active_icons_book
                        : ""
                    }`}
                    style={{ cursor: "pointer" }}
                    onClick={(e) => handleFilter(e, "status")}
                  >
                    filter_list
                  </span>
                  {isOpen.status === true && (
                    <div
                      className="filterBoxs_testlist mt-2"
                      ref={filterStatusRef}
                    >
                      <div className="col-md-12 form-check filterStatus_list">
                        <ul className="ulFilterListData">
                          <li className="filterListData">
                            <input
                              className="ListCheckbox"
                              type="checkbox"
                              name="Absent"
                              value="0"
                              id="Absent"
                              checked={selectedStatus.some(
                                (el) => el.id === "0"
                              )}
                              onChange={(e) => {
                                if (e.target.checked) {
                                  setselectedStatus([
                                    { id: "0", name: "Absent", type: "status" },
                                  ]);
                                } else {
                                  setselectedStatus([]);
                                }
                              }}
                            />
                            <label
                              className="form-check-label filterChipText bg-green"
                              htmlFor="Absent"
                            >
                              Absent
                            </label>
                          </li>
                          <li className="filterListData">
                            <input
                              className="ListCheckbox"
                              type="checkbox"
                              name="Completed"
                              value="1"
                              id="Completed"
                              checked={selectedStatus.some(
                                (el) => el.id === "1"
                              )}
                              onChange={(e) => {
                                if (e.target.checked) {
                                  setselectedStatus([
                                    {
                                      id: "1",
                                      name: "Completed",
                                      type: "status",
                                    },
                                  ]);
                                } else {
                                  setselectedStatus([]);
                                }
                              }}
                            />
                            <label
                              className="form-check-label bg-orange filterChipText"
                              htmlFor="Completed"
                            >
                              Completed
                            </label>
                          </li>
                        </ul>
                      </div>
                      <div className="borderWidth row">
                        <ul className="List-Button">
                          <li className="ListBtnItems">
                            <Link
                              to={"javascript:void(0)"}
                              onClick={() => {
                                setselectedStatus([]);
                                handleClear("status");
                              }}
                              className="secondaryButton"
                            >
                              Clear
                            </Link>
                          </li>
                          <li className="ListBtnItems">
                            <Link
                              onClick={() => {
                                handleApplyFilter();
                                setIsopen({ ...isOpen, status: false });
                              }}
                              className="primaryButton"
                            >
                              Apply Filter
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  )}
                </th>
                {/* Action */}
                <th id="th">
                  <span className="textHead_th">Action</span>
                </th>
              </tr>
            </thead>
            <tbody>
              {currentData && currentData.length > 0 ? (
                currentData.map((item, index) => (
                  <tr key={index}>
                    <td>{item.event_name}</td>
                    <td>
                      {item.start_date
                        ? new Date(item.start_date).toLocaleDateString(
                            "en-GB",
                            {
                              day: "2-digit",
                              month: "short",
                              year: "numeric",
                            }
                          )
                        : "-"}
                    </td>
                    <td>
                      <span
                        title={item.subject?.map((s) => s.subject).join(", ")}
                        className="ellipsisText"
                      >
                        {item.subject?.map((s) => s.subject).join(", ")}
                      </span>
                    </td>
                    <td>
                      <span
                        title={item.test_topic
                          ?.map((t) => t.test_topic)
                          .join(", ")}
                        className="ellipsisText"
                      >
                        {item.test_topic?.map((t) => t.test_topic).join(", ")}
                      </span>
                    </td>
                    <td>
                      {item.status === 1 ? (
                        <span className="filterChipText bg-orange mx-0">
                          Completed
                        </span>
                      ) : (
                        <span className="filterChipText bg-green mx-0">
                          Absent
                        </span>
                      )}
                    </td>
                    <td>
                      <button
                        className={"view_icon_button"}
                        onClick={() =>
                          handleView(
                            item.event_pk,
                            item.batch_id,
                            item.status,
                            item.event_type,
                            item.type
                          )
                        }
                      >
                        <span className={`visibleicon material-icons`}>
                          visibility
                        </span>
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" style={{ textAlign: "center" }}>
                    No records to display
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      <div className="row mt-2">
        <Pagination
          rowsPerPage={rowsPerPage}
          handlePageCount={handlePageCount}
          startPage={totalRecords > 0 ? start + 1 : 0}
          endPage={totalRecords > 0 ? Math.min(end, totalRecords) : 0}
          totalRecords={totalRecords}
          handlePrev={() => handlePrev(currentPage - 1)}
          currentPrevPage={currentPage === 1}
          prevButton={`${styles.prev_button} ${styles.materialIconsRightAndLeft} me-2`}
          handleNext={() => handleNext(currentPage + 1)}
          currentNextPage={currentPage === totalPages || totalPages == 0}
        />
      </div>
    </div>
  );
}
export default ClassPerformance;
